import { RegisterReportingDateRangeWithDescription } from './register-reporting-date-range';

export const REPORTING_YEAR_DATES: RegisterReportingDateRangeWithDescription[] = [
  { startDay: 1, startMonth: 1, description: 'January → December' },
  { startDay: 1, startMonth: 2, description: 'February → January' },
  { startDay: 1, startMonth: 3, description: 'March → February' },
  { startDay: 1, startMonth: 4, description: 'April → March' },
  { startDay: 1, startMonth: 5, description: 'May → April' },
  { startDay: 1, startMonth: 6, description: 'June → May' },
  { startDay: 1, startMonth: 7, description: 'July → June' },
  { startDay: 1, startMonth: 8, description: 'August → July' },
  { startDay: 1, startMonth: 9, description: 'September → August' },
  { startDay: 1, startMonth: 10, description: 'October → September' },
  { startDay: 1, startMonth: 11, description: 'November → October' },
  { startDay: 1, startMonth: 12, description: 'December → November' },
];

export function findReportingYearDate(
  startMonth: number | undefined,
  startDay = 1,
): RegisterReportingDateRangeWithDescription | undefined {
  return REPORTING_YEAR_DATES.find(d => d.startMonth === startMonth && d.startDay === startDay);
}
